<script>
import { mapGetters, mapActions } from 'vuex'

import Layout from '@layouts/main'
import appConfig from '@src/app.config'
import Paginate from '@components/paginate'
import Actionbar from '@components/actionbar'
import PageHeader from '@components/page-header'
import { toggleActionMenu } from '@/src/utils/toggleActionMenu'
import CategoryView from '@components/announcement/category/category-list'
import CategoryEdit from '@components/announcement/category/edit'
import CategoryCreate from '@components/announcement/category/create'
/**
 * Announcement component
 */
export default {
  page: {
    title: 'Category',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  name: 'Category',
  components: {
    Layout,
    Paginate,
    Actionbar,
    PageHeader,
    CategoryEdit,
    CategoryView,
    CategoryCreate,
  },

  data() {
    return {
      title: 'Category',
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Category',
          active: true,
        },
      ],
      defaultPerPage: 15,
      categoryActions: [
        {
          id: 'home',
          name: 'Home',
          targetElement: 'home',
          buttontype: 'button',
          cssclass: 'uil uil-home',
          method: () => {
            this.mark(0)
            this.toggleCategorys = 'Home'
          },
        },
        {
          id: 'create-category',
          name: 'Create',
          targetElement: 'create',
          buttontype: 'button',
          cssclass: 'uil uil-plus-square',
          method: () => {
            this.$data.toggleCategorys = 'Create'
          },
        },
      ],
      categoryActiveActions: [
        {
          id: 'edit-category',
          name: 'Edit',
          targetElement: 'edit',
          buttontype: 'link',
          cssclass: 'uil uil-edit',
          method: (category) => {
            this.category = category
            this.$data.toggleCategorys = 'Edit'
            this.mark(0)
          },
        },
        {
          id: 'delete-category',
          name: 'Delete',
          targetElement: 'Delete',
          buttontype: 'link',
          cssclass: 'uil uil-trash-alt',
          method: (category) => {
            this.$root.$children[0].$on('delete_category', () => {
              this.$store.dispatch('category/removeCategory', category)
              this.$root.$children[0].modalContent.eventName = ''
              delete this.$root.$children[0]._events['delete_delete_category']
            })
            this.actionClicked('Home')
            this.$root.$children[0].showModal = true
            this.$root.$children[0].modalContent.eventName = 'delete_category'
          },
        },
      ],
      marked: 0,
      actionMenus: [],
      category: {},
      toggleCategorys: 'Home',
    }
  },
  computed: {
    ...mapGetters('category', [
      'allCategories',
      'perPage',
      'totalPages',
      'currentPage',
      'totalRecords',
    ]),
    currentSection() {
      return Math.floor(this.currentPage / this.defaultPerPage)
    },
  },
  created() {
    this.getCategories({ page: 1, perPage: this.defaultPerPage })
    this.actionMenus = toggleActionMenu(
      this.categoryActions,
      this.categoryActiveActions,
      false
    )
  },
  methods: {
    ...mapActions('category', ['getCategories']),
    actionClicked(name) {
      this.actionMenus.filter((action) => {
        if (action.name === name) action.method(this.category)
      })
    },
    mark(marked) {
      this.marked = marked !== this.marked ? marked : 0
      this.allCategories.forEach((ann) => {
        if (ann.id === marked) {
          this.category = Object.assign({}, ann)
        }
      })
      this.actionMenus = toggleActionMenu(
        this.categoryActions,
        this.categoryActiveActions,
        this.marked
      )
    },
    loadPage(page) {
      let requestedPage = page < 1 ? this.totalPages : page
      if (requestedPage !== this.currentPage)
        this.getAnnouncements({
          page: requestedPage,
          perPage: this.defaultPerPage,
        })
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <Actionbar :call="actionClicked" :items="actionMenus" />
    <transition name="slide" tag="div" class="row">
      <CategoryCreate
        v-if="toggleCategorys === 'Create'"
        :call="actionClicked"
      />
      <CategoryEdit
        v-else-if="toggleCategorys === 'Edit'"
        :category="category"
        :action-clicked="actionClicked"
      />
      <CategoryView
        v-else
        :actions="categoryActiveActions"
        :action-clicked="actionClicked"
        :call="mark"
        :marked="marked"
      />
    </transition>
    <Paginate
      v-if="totalPages > 1 && toggleCategorys === 'Home'"
      :current-page="currentPage"
      :total-pages="totalPages"
      :current-section="currentSection"
      :load-page="loadPage"
      :total-records="totalRecords"
    />
  </Layout>
</template>
